// This is in a separate file due to based bug BAS-16
import type { ReactNode } from 'react'
import { styled, type Style } from 'inlines'
import { Property } from 'csstype'

export type { Style }

export type CardWrapperProps = {
  children: ReactNode
  padding?: Property.Padding
  style?: Style
  onClick?: VoidFunction
}

type CardWrapperButtonProps = {
  children: ReactNode
  onClick: VoidFunction
  style: Style
}

export const CardWrapperButton = ({
  children,
  onClick,
  style,
}: CardWrapperButtonProps) => (
  <styled.button type="button" onClick={onClick} style={style}>
    {children}
  </styled.button>
)

type CardWrapperRootProps = {
  children: ReactNode
  style: Style
}

export const CardWrapperRoot = ({ children, style }: CardWrapperRootProps) => (
  <styled.div style={style}>{children}</styled.div>
)
